import { ModuleId } from "flavr-common";
import { NewModule } from "@modules/module/NewModule";
import { inputService } from "@modules/inputs/input/InputService";
import { VrToastMessage } from "@messages/xr/WebXRMessages";
export let showUI3dCursor = false;
const cursorChangeListeners = new Set();
export function subscribeCursorChange(cb) {
    cursorChangeListeners.add(cb);
    return () => cursorChangeListeners.delete(cb);
}
function setShowUi3dCursor(value) {
    showUI3dCursor = value;
    for (const cb of cursorChangeListeners)
        cb(value);
}
/**
 * Provides the developer-only toggle for the in-world 3D UI cursor: registers an input action that flips the
 * cursor's visibility, notifies subscribers of the change and sends a toast confirming the new state.
 */
export class UI3DModule extends NewModule {
    constructor() {
        super(ModuleId.UI3D);
    }
    /**
     * Registers the developer input action that toggles the in-world 3D UI cursor's visibility and sends a toast
     * message confirming the new state.
     */
    onInit() {
        inputService
            .registerAction("ToggleUi3dCursor", () => {
            const label = showUI3dCursor ? "Disabled UI Cursor" : "Enabled UI Cursor";
            setShowUi3dCursor(!showUI3dCursor);
            console.debug(`[ui3d] ${label}`);
            this.connection.send(new VrToastMessage(label));
        })
            .addKey("KeyT")
            .asDev();
    }
}
